export const FETCH_ABOUT_REQUEST = 'FETCH_ABOUT_REQUEST'
export const FETCH_ABOUT_SUCCES = 'FETCH_ABOUT_SUCCES'
export const FETCH_ABOUT_ERROR = 'FETCH_ABOUT_ERROR'



// WEBPACK FOOTER //
// ./src/constants/About.js